import {
  IRepeatableElement,
  RepeatableSchemaValidator,
} from "@graffer-inc/form-schema";
import { ErrorMessage } from "./helper";
import { TargetsCopyableEditor } from "./targets-copyable-editor/targets-copyable-editor";
import { ExternalLink, MarkdownEditor } from "@graffer-inc/console-design-kit";
import {
  markdownHelpLink,
  grafferSchemasSuportTagNames,
} from "../../../../../../utils/markdown/constants";

type RepeatableEditorProps = {
  element: IRepeatableElement;
  onElementUpdate: (arg: IRepeatableElement) => void;
};

export const RepeatableEditor: React.FC<RepeatableEditorProps> = ({
  element,
  onElementUpdate,
}) => {
  const schemaValidator = new RepeatableSchemaValidator(element);

  const labelId = `${element.id}-label`;
  const descriptionId = `${element.id}-description`;

  return (
    <>
      <div className="field">
        <label className="label" htmlFor={labelId}>
          項目名
        </label>
        <div className="control">
          <p id={labelId}>{element.label.text}</p>
        </div>
      </div>
      <div className="field">
        <div className="label is-flex is-justify-content-space-between is-align-items-baseline mb-0">
          <label className="mb-2" htmlFor={descriptionId}>
            説明文
          </label>
          {element.description.isMarkdown && (
            <ExternalLink
              anchor={(props) => (
                <a
                  {...props}
                  href={markdownHelpLink}
                  target={"_blank"}
                  rel={"noopener noreferrer"}
                >
                  {props.children}
                </a>
              )}
            >
              入力方法やサンプルはこちら
            </ExternalLink>
          )}
        </div>
        <div className="control">
          {element.description.isMarkdown ? (
            <MarkdownEditor
              value={element.description.text}
              layout="standalone"
              allowedTagNames={grafferSchemasSuportTagNames}
              editAreaOptions={{
                attributes: {
                  id: descriptionId,
                  placeholder: "未設定",
                  rows: 5,
                },
              }}
              onChange={(text) => {
                onElementUpdate({
                  ...element,
                  description: { ...element.description, text },
                });
              }}
            />
          ) : (
            <textarea
              style={{ minHeight: "72px" }}
              id={descriptionId}
              className="input"
              rows={4}
              placeholder="未設定"
              value={element.description.text}
              onChange={(e) => {
                onElementUpdate({
                  ...element,
                  description: {
                    ...element.label,
                    text: e.target.value,
                  },
                });
              }}
            />
          )}
        </div>
        <ErrorMessage msg={schemaValidator.description()} />
      </div>
      <div className="field">
        <label className="label">項目を必須項目にする</label>
        <div className="control">
          <label className="checkbox">
            <input type="checkbox" checked={element.required} disabled />
            必須にする
          </label>
        </div>
      </div>
      <div className="field">
        <label className="label">最小繰り返し回数</label>
        <div className="control">
          <p>{element.minLength}</p>
        </div>
      </div>
      <div className="field">
        <label className="label">最大繰り返し回数</label>
        <div className="control">
          <p>{element.maxLength}</p>
        </div>
      </div>
      <TargetsCopyableEditor element={element} />
    </>
  );
};
